class SantanderBank4 {

    constructor() {
        this.init();
    }

    private init() {
        this.menu();
        this.setFormFields();
        this.scrollView();
        this.hideButton();
        this.panelForm();
        this.servicesPopup();
        this.tooltip();
    }

    private menu() {
        let menuHamburger = document.querySelector('.header-hamburger');
        let menuButtons = document.querySelector('.header-buttons');
        menuHamburger.addEventListener('click', function() {
            if(menuButtons.classList.contains('show')) {
                menuButtons.classList.remove('show');
            } else {
                menuButtons.classList.add('show');
            }
        });
    }

    private setFormFields() {
        let regulationInput = document.querySelector('.regulationInput');
        if(regulationInput) {
            let regulationField = regulationInput.parentElement;
            regulationField.classList.add('regulation');

            let regulationLabel = regulationField.querySelector('label').innerHTML;
            let regulationLabelReg = /(.+)(Regulaminu Promocji.+)/;
            let label_matches = regulationLabel.match(regulationLabelReg);
            if(label_matches) {
                let href = document.querySelector('.form-rules .campaign-rules-link').getAttribute('href');
                let link = `${label_matches[1]} <a class="regulation-link" href="${href}">${label_matches[2]}</a>`;
                regulationField.querySelector('label').innerHTML = link;
            }

            let text = document.createElement('div');
            text.classList.add('form-text');
            text.innerHTML = `<p>Wyrażam zgodę na otrzymywanie od Bonnier Business (Polska) informacji handlowej drogą elektroniczną dotyczących:</p>`;
            this.insertAfter(regulationField, text);
        }

        let clauseInput = document.querySelector('.clauseInput');
        if(clauseInput) {
            let clauseField = clauseInput.parentElement;
            clauseField.classList.add('clause');

            let showMore = document.createElement('div');
            showMore.innerHTML = '(rozwiń)';
            showMore.classList.add('shortClauseButton');
            showMore.addEventListener('click', function() {
                clauseField.classList.add('-show');
            });

            let helpText = clauseInput.parentElement.querySelector('.help-text');
            helpText.append(showMore);

            let text = document.createElement('div');
            text.classList.add('form-text');
            text.innerHTML = `<p>Administratorem danych osobowych w Promocji „Zgarnij Premię z Kontem Firmowym Godnym Polecenia Santander Bank Polska edycja&nbsp;4” jest Santander Bank Polska S.A. z siedzibą w Warszawie. Szczegółowe zasady przetwarzania danych  osobowych zostały ujęte w Polityce przetwarzania danych osobowych dostępnej na santander.pl</p>
            <p>Zaakceptowanie powyższego oświadczenia i wyrażenie powyższej zgody jest dobrowolne, lecz niezbędne do udziału w Promocji Zgarnij Premię z Kontem Firmowym Godnym Polecenia Santander Bank Polska edycja 4”</p>`;

            clauseField.insertBefore(text, helpText);
        }
    }

    private insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    private scrollView() {
        const url = window.location.href;
        const pathname = window.location.pathname;

        if (pathname.indexOf('zaloguj') !== -1) {
            let loginForm = document.querySelector('.login-form')
            window.scrollTo({
                top: (loginForm as HTMLElement).offsetTop - 20,
                left: 0,
                behavior: 'smooth'
            });
        } else if (pathname.indexOf('zmien-haslo') !== -1) {
            let passwordForm = document.querySelector('.password-form')
            window.scrollTo({
                top: (passwordForm as HTMLElement).offsetTop - 20,
                left: 0,
                behavior: 'smooth'
            });
        } else if (url.indexOf('#register-form') !== -1) {
            let registerForm = document.getElementById('register-form');
            let registerMessage = document.querySelector('.register-message');
            let offset = 0;
            if(registerForm) {
                offset = (registerForm as HTMLElement).offsetTop;
            } else {
                offset = (registerMessage as HTMLElement).offsetTop;
            }
            window.scrollTo({
                top: offset - 100,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    private hideButton() {
        let lead_button = document.querySelector('#bs-elead-btn');
        if(lead_button) {
            lead_button.addEventListener('click', function() {
                (lead_button as HTMLElement).style.display = 'none';
                (document.querySelector('#bs-elead-blocked') as HTMLElement).style.display = 'block';
            });
        }
    }

    private panelForm() {
        let rodoExpandButton = document.querySelector('.bs-rodo-expand');
        let rodoShortText = document.querySelector('.bs-rodo-short');
        let rodoLongText = document.querySelector('.bs-rodo-long');

        if(rodoExpandButton) {
            rodoExpandButton.addEventListener('mouseover', function() {
                (rodoExpandButton as HTMLElement).style.display = 'none';
                (rodoShortText as HTMLElement).style.display = 'none';
                (rodoLongText as HTMLElement).style.display = 'inline-block';
            });
        }
    }

    private servicesPopup() {
        let servicesButtons = document.querySelectorAll('.services-button-more');
        for(let i = 0; i < servicesButtons.length; i++) {
            servicesButtons[i].addEventListener('click', () => {
                let servicesPopup = document.querySelector('.services-popup');
                if(servicesPopup) {
                    servicesPopup.classList.add('-open');
                }
                let popupHide = document.querySelector('.services-popup .popup.-show');
                if(document.querySelector('.services-popup .popup.-show')) {
                    popupHide.classList.remove('-show');
                }
                let popupShow = document.querySelector(`.services-popup .popup-${i + 1}`);
                if(popupShow) {
                    popupShow.classList.add('-show');
                }
                document.body.style.overflow = 'hidden';
            });
        }
        let servicesButtonsClose = document.querySelectorAll('.popup-close');
        for(let i = 0; i < servicesButtonsClose.length; i++) {
            servicesButtonsClose[i].addEventListener('click', () => {
                servicesButtonsClose[i].parentElement.classList.remove('-show');
                servicesButtonsClose[i].parentElement.parentElement.classList.remove('-open');
                document.body.style.overflow = 'auto';
            });
        }
    }

    private tooltip() {
        let tooltips = document.querySelectorAll('.tooltip');
        for(let i = 0; i < tooltips.length; i++) {
            tooltips[i].addEventListener('mouseover', () => {
                let tooltipInfo = tooltips[i].parentElement.querySelector('.tooltip-info');
                if(tooltipInfo) {
                    (tooltipInfo as HTMLElement).style.display = 'block';
                }
            });
            tooltips[i].addEventListener('mouseleave', () => {
                let tooltipInfo = tooltips[i].parentElement.querySelector('.tooltip-info');
                if(tooltipInfo) {
                    (tooltipInfo as HTMLElement).style.display = 'none';
                }
            });
        }
    }
}

let santanderBank = new SantanderBank4();
